import { defineStore } from 'pinia'
import {ref, computed, unref, reactive, toRaw} from 'vue'
import useCruiseBook from '@/comp/useCruiseBook.js'
import {getCruiseRoomsAges} from '@/comp/useCruise.js'
import {isCabinFree} from '@/comp/useCruiseBook.js'
import useTouristStore from '@/tourist/tourist-store.js'
import useCabinsStore from '@/bookCabins.js'
import {intersect} from '@/actions.js'
import {LOCALSTOR_TOURIST_KEY} from '@/localStor.js'



import {
    cruises, cruises_sort_key, cruises_page, cruise_next_pageob, cruises_limit,
    shipOne2 as shipOne,
    cruiseOne2 as cruiseOne,
    _get,
    random_str,
    findLast,
} from '@/actions.js'

import { pauze } from '@/util.js'


let uid_counter = 0 
export const uid_func = ( prefix ) => () => {
    uid_counter = uid_counter + 1
    let rand = random_str()
    return `${prefix}${uid_counter}.${rand}`
}

export const CRUISE_CONSTRUCTOR = "cnstr"
export const AGES_CONSTRUCTOR = {
    child: {since: 0, till: 17, src: 'front'},
    infant: {since: 0, till: 5, src: 'front'}
}
export const CABIN_CONSTRUCTOR = 999


export default defineStore('cruise', () => {
    const tstore = useTouristStore()
    const bookCabins = useCabinsStore()
    const crsearch = ref([])
    const crlistsearch = ref([])
    const cabinShipBox = reactive({
        cruiseIdFull: '',
        CabinShip: [],
        key: '',
    })
    const shipOneBox = {
        data: ref([]),
        head: ref(""),
        create_id: uid_func('ship'),
    }
    const cruiseBookBox = {
        data: ref([]),
        head: ref(""),
        create_id: uid_func('bb'),
    }
    const pokazatShowDop = ref(false)

    const loadCruiseBook = (params) => {
        const {data, head, create_id} = cruiseBookBox
        const id=create_id()
        const rec={
            id,
            params,
            wait: true,
            ok: null,
            resolve: null,
            reject: null,
        }

        data.value.push(rec) // запуск поиска 
        head.value=id
        const proc = ({resolve, reject}) => {// поиск завершился
            if (id !== head.value) { // новый поиск пришел до завершения rec
                data.value = data.value.filter( ob => ob.id !== id ) // удаляем неактуальную запись
                return Promise.reject('не актуально')
            }

            const ok=resolve ? true : false
            const wait=false

            Object.assign(rec, {ok, wait, resolve , reject})
            if (ok) {
                tstore.pers_load_localstor(  LOCALSTOR_TOURIST_KEY )
                const { ages, cruiseIdFull, roomsMap, max_cabins } = getCruiseRoomsAges( resolve )
                const tstore_sids = tstore.pers.map( p => p.sid )
                bookCabins.initBookBox( {
                    cruiseIdFull,
                    ages,
                    roomsMap,
                    max_cabins,
                    tstore_sids,
                    key: id
                } )
                tstore.cleanEmpty( bookCabins.getUsedSids() )
            }

            const ret = ok ? resolve : Promise.reject(reject) 
            return ret
        }

        let params_one={ cruiseIdFull: params.cruiseIdFull, key:id  }
        return cruiseOne( params_one ).then( 
            resolve => proc( {resolve } ),
            reject =>  proc( {reject} )
        )
    }

    const getCabinCons = computed( () => {
        const {cabins, occupancy, ages}= bookCabins.bookBox
        const id = CABIN_CONSTRUCTOR
        const cabinOccupation = occupancy[ id ]
        const Cabin = {id, name: 'Конструктор'}
        return {...cabinOccupation, Cabin, id, ages}
    })


    const getCabins = computed( () => {
        let ret = []
//        console.log('getCabins bookCabins.bookBox', bookCabins.bookBox)
        const {cabins, occupancy, ages}= bookCabins.bookBox
        if (cabins && cabins.length) {
            const {CabinMap}=unref(getCruiseBook)
            ret = cabins.map(({id}) => {
                const cabinCabinSet = CabinMap[ id ]
                const cabinOccupation = occupancy[ id ]
                /*
                Cabin, CabinSet
                places,
                acc,
                id,
                adult,
                child,
                infant,
                */
                return {...cabinCabinSet, ...cabinOccupation, ages }
            })
        }
        return ret
    })

    const getCruiseBook = computed(() => {
        const {data, head} = cruiseBookBox
        const is = data.value.length ? true : false
        let box 
        if (is) {
            box = data.value.at(-1)
        } else {
            box = { params: null, wait: null, ok: null, resolve: null, reject: null, }
        }
        const cruiseBook = useCruiseBook(box.resolve)
        const ret = { is, ...box, ...cruiseBook}
        return ret
    })


    const loadShip = (params) => {
        const {data, head, create_id} = shipOneBox
        const id=create_id()
        const rec={
            id,
            params,
            wait: true,
            ok: null,
            resolve: null,
            reject: null,
        }
        data.value.push(rec) // запуск поиска 
        head.value=id
        const proc = ({resolve, reject}) => {// поиск завершился
            if (id !== head.value) { // новый поиск пришел до завершения rec
                data.value = data.value.filter( ob => ob.id !== id ) // удаляем неактуальную запись
                return Promise.reject('не актуально')
            }

            const ok=resolve ? true : false
            const wait=false

            Object.assign(rec, {ok, wait, resolve, reject})

            return ok ? resolve : Promise.reject(reject) 
        }


        return shipOne( params ).then(resolve => proc({resolve}), reject => proc({reject}) )
    }
    const getShip = computed(() => {
        const {data, head} = shipOneBox
        let is = data.value.length ? true : false
        let ret
        if (is) {
            ret = { is, ...data.value.at(-1) }
        } else {
            ret = {
                is, params: null, wait: null, ok: null, resolve: null, reject: null
            }
        }
        return ret
    })

    const crsearch_start= (params) => {
        crsearch.value = crsearch.value.slice(-1);// удаляем предыдущие поиски, оставляем только последний
        const rec={
            id: Date.now().toString(),
            params: params || {},
            wait: true,
            isEmpty: true,
            ok:null,
            resolve: null,
            reject: null,
        }
        crsearch.value.push(rec)
//window.xxx0=[ crlistsearch, crsearch ]

        const proc = ({resolve, reject})=> {
            if (false) {// чтобы увидеть ошибку
                resolve = null 
                reject = 'какой-то недо текст'
            }
            const ok=resolve ? true : false
            const wait=false
            const isEmpty= ok && resolve.list.length > 0 ? false : true

            Object.assign(rec, {ok, wait, isEmpty, resolve, reject})

            const listrec={
                search_id: rec.id,
                sort_key:  cruises_sort_key(params),
                okpage:    cruises_page(params),
                pages:     [{ok, wait, resolve, reject}]
            }
            crlistsearch.value.push(listrec)


            return ok ? resolve : Promise.reject(reject) 
        }

        if (false) {// чтобы сделать все с задержкой
            return cruises(params).then( 
                resolve => pauze(5000).then( () => proc({resolve}) ),
                reject => proc({reject}) 
            )
        }
        return cruises(params).then(resolve => proc({resolve}), reject => proc({reject}) )
    }

    function clean_crlistsearch() {
        let ids = crsearch.value.map( ({id}) => id )
        crlistsearch.value = crlistsearch.value.filter( ({search_id}) => ids.includes(search_id)  )
    }

    function crlistsearch_first( search_id, sort_par ) {
        clean_crlistsearch() 
        const rec=crsearch.value.find( rec => rec.id===search_id)
        if (!rec) {
            return Promise.reject('поиск устарел')
        }
        const sort_key=cruises_sort_key( Object.assign({}, rec.params, sort_par) )
        const found=findLast( 
            crlistsearch.value, 
            listrec => listrec.search_id === search_id && listrec.sort_key === sort_key
        )
        let ret
        if (!found) {
            ret=crlistsearch_next( search_id, sort_par )
        } else {
            let listrec=found
            let rec=listrec.pages.at(-1)
            if (listrec.okpage || rec.wait) {
                ret=Promise.reject( 'уже есть что показать' )
            } else {
                ret=crlistsearch_next( search_id, sort_par )
            }
        }
        return ret
    }

    function crlistsearch_next( search_id, sort_par ) {
        const rec=crsearch.value.find( rec => rec.id===search_id)
        if (!rec) {
            return Promise.reject('поиск устарел')
        }

        const sort_key=cruises_sort_key( Object.assign({}, rec.params, sort_par) )
        const found=findLast( 
            crlistsearch.value, 
            listrec => listrec.search_id === search_id && listrec.sort_key === sort_key
        )
        let listrec=found
        const recpage={ok:null, wait:true, resolve:null, reject:null}
        if (!listrec) {
            listrec={
                search_id,
                sort_key,
                okpage: null, // пока нет
                pages: [recpage]
            }
            crlistsearch.value.push(listrec)
        }else{
            if (listrec.pages.at(-1).wait) {
                return Promise.reject('дождитесь завершения')       
            }
            listrec.pages.push(recpage)
        }

        const params=Object.assign( {}, rec.params, sort_par, cruise_next_pageob(listrec.okpage) )

        const proc = ({resolve, reject})=> {
            const ok=resolve ? true : false
            const okpage = resolve ? cruises_page(params) : listrec.okpage
            const wait=false
//            const isEmpty= ok && resolve.list.length > 0 ? false : true

            Object.assign(recpage, {ok, wait, resolve, reject})
            Object.assign(listrec, {okpage})

            return ok ? resolve : Promise.reject(reject) 
        }


        return cruises( params ).then(resolve => proc({resolve}), reject => proc({reject}) )
    }

    const crlistsearch_list = ( search_id, sort_par )=> {
        const rec=crsearch.value.find( rec => rec.id===search_id)
        if (!rec) {// не должно произойти(!), все сохраняется при норм раскладе
            return {isWait:false, isFull:true, list:[], isFail: true, ret_params: {}} 
        }
        const ret_params = Object.assign( {}, rec.params, sort_par)

        const sort_key=cruises_sort_key( sort_par )
        const found=findLast( 
            crlistsearch.value, 
            rec => rec.search_id === search_id && rec.sort_key===sort_key
        )
        if (!found) {
            return {isWait:false, isFull:true, list:[], isFail: true, ret_params, count: 0}
        }
        let listrec=found
        const {list,count}=listrec.pages.reduce( (akk, recpage) => {
            if (recpage.ok) {
                akk.list = akk.list.concat( recpage.resolve.list )
                akk.count = recpage.resolve.count
            }
            return akk
//            return recpage.ok ? list.concat( recpage.resolve.list ) : list
        }, {list:[],count: 0} )

        const last=listrec.pages.at(-1)
        const isWait=last.wait
        const isFull=last.ok && last.resolve.list.length < cruises_limit(sort_par)
        const isFail = last.wait || last.ok ? false : true
        return {isWait, isFull, list, isFail, ret_params, count}
    }

    const crsearch_last = computed( ()=> {
//        return crsearch.length
//        return true
        let rec= crsearch.value.at(-1)
        if (!rec) {
            rec={ id: -1, is: false, wait: false, } // сравнение не должно совпадать
        } else {
            rec={ ...rec, is:true }
        }
        return rec
    }  )

    const crsearch_last_notempty = computed( ()=> {
//        return crsearch.length
//        return true
        let rec= findLast( crsearch.value, rec => !rec.isEmpty )
        if (!rec) {
            rec={ id: -1, is: false } // сравнение не должно совпадать
        } else {
            rec={ ...rec, is:true }
        }
        return rec
    }  )


    return { 
        crsearch, crlistsearch, crlistsearch_next, crlistsearch_first, 
        crsearch_start, crsearch_last, crsearch_last_notempty,
        crlistsearch_list, 

        loadShip, getShip, 
            shipOneBox_data: shipOneBox.data, shipOneBox_head: shipOneBox.head,
        loadCruiseBook, getCruiseBook, 
            cruiseBook_data: cruiseBookBox.data, cruiseBook_head: cruiseBookBox.head,
        getCabins,
        pokazatShowDop,
        getCabinCons,
    }

})
